import { Portal } from 'portal-vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({ name: 'ExpiryTimer', components: { Portal } })
export default class default_1 extends Vue {
    t;
    @Prop()
    expiresIn;
    // Threshold in seconds
    thresholdWarning = 5 * 60;
    thresholdError = 2 * 60;
    thresholdCritical = 30;
    get expiryMinutes() {
        return this.expiresIn.minutes();
    }
    get expirySeconds() {
        return this.expiresIn.seconds();
    }
    get timeRemainingInSeconds() {
        return Math.floor(this.expiresIn.asSeconds());
    }
    // Screen readers announce the section when aria-live changes from 'off' to 'polite'.
    // Set it to 'off' so it doesn't read updates every second.
    get shouldAnnounceExpiryToScreenReader() {
        const thresholds = [this.thresholdWarning, this.thresholdError, this.thresholdCritical];
        if (thresholds.includes(this.timeRemainingInSeconds)) {
            return 'polite';
        }
        else {
            return 'off';
        }
    }
    get formattedTime() {
        const expiresIn = this.expiresIn;
        if (expiresIn.asSeconds() > 0) {
            return expiresIn.format('m:ss');
        }
        else {
            return null;
        }
    }
    get timerStatus() {
        if (this.timeRemainingInSeconds > this.thresholdWarning) {
            return 'info';
        }
        else if (this.timeRemainingInSeconds > this.thresholdError) {
            return 'warning';
        }
        else {
            return 'error';
        }
    }
    get screenReaderTimer() {
        return this.$t('expiryTimer.screenReaderExpiresIn', {
            minutes: this.expiryMinutes,
            seconds: this.expirySeconds,
        });
    }
}
